import request from "@utils/request";
/**
 * 获取上一场拼团用户数据
 *
 */
export function ptUpUserList(data) {
  return request.get("product/ptUpUserList", data);
}

/**
 * 获取拼团用户数据
 *
 */
export function ptUserList(data) {
  return request.get("product/ptUserList", data);
}
